import React from "react";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import type { UnitGroup } from "@/types";
import { formatUnitDimensions } from "@/utils/units/format";

interface UnitDimensionProps {
    unitGroup: UnitGroup;
}

export const UnitDimension = ({ unitGroup }: UnitDimensionProps) => {
    const [openId, setOpenId] = React.useState<number | null>(null);
    const representativeUnit = unitGroup.representative_unit;
    const category = representativeUnit.category;

    const unitWidth = unitGroup.representative_unit.width;
    const unitLength = unitGroup.representative_unit.length;

    const dimensionLabel = formatUnitDimensions(unitWidth, unitLength);

    // No size → no label (and nothing to anchor the category tooltip to).
    if (dimensionLabel === "") {
        return null;
    }

    return (
        <>
            {category.description ? (
                <TooltipProvider>
                    <Tooltip
                        open={openId === category.id}
                        onOpenChange={(isOpen) =>
                            setOpenId(isOpen ? category.id : null)
                        }
                    >
                        <TooltipTrigger asChild>
                            <span
                                onClick={() =>
                                    setOpenId(
                                        openId === category.id
                                            ? null
                                            : category.id,
                                    )
                                }
                            >
                                {dimensionLabel !== "" && (
                                    <span className="category-icon"></span>
                                )}
                                {dimensionLabel}
                            </span>
                        </TooltipTrigger>
                        <TooltipContent className="tw:max-w-[360px]">
                            <p>
                                {category.description}
                            </p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            ) : (
                <span>{dimensionLabel}</span>
            )}
        </>
    );
};
